// Module
var code = `<dx-button *ngIf="this.visible" type="default" stylingMode="contained" (onClick)="this.settingsPopUpService.popupControl.toggleVisibility()"> <i class="fa-solid fa-cog"></i> </dx-button> `;
// Exports
export default code;